export const CENSHARE_REQUIRED_FIELDS_MISSING = 'CENSHARE_REQUIRED_FIELDS_MISSING';
export const CENSHARE_SCHEMA_INVALID = 'CENSHARE_SCHEMA_INVALID';
export const CENSHARE_PRODUCT_NOT_RELEASED = 'CENSHARE_PRODUCT_NOT_RELEASED';
